import {
  backingButtonStyles,
  proposedButtonStyles,
} from './ActionsGridStyles';
import { elementButtonStyleOverride } from '../../molecules/Profile/ProfileActionButtonStyles';
import appStrings from '../../app_strings';

const {
  profile:
  {
    actionButtons: {
      back,
      backing,
      proposed,
    },
  },
} = appStrings;

export const getBackButtonLabel = (subjectProfile) => {
  const { relationshipStatus } = subjectProfile;
  if (relationshipStatus?.isBackingThisUser) {
    return backing;
  }
  if (relationshipStatus?.isBackingThisUserProposed) {
    return proposed;
  }

  return back;
};

export const getButtonStyles = (label) => {
  switch (label) {
    case 'Backing':
      return backingButtonStyles;
    case 'Proposed':
      return proposedButtonStyles;
    case null:
      return elementButtonStyleOverride;
    default:
      return {};
  }
};
